import { useMutation } from '@apollo/client'
import {
  UPDATE_CUSTOMER_DISPLAY_MY_CIRCLE,
  GET_CUSTOMER_DISPLAY_MY_CIRCLE,
} from '../graphql'

export interface UpdateCustomerDisplayMyCircleInput {
  customerUuid: string
  displayMyCircle: boolean
}

export interface UpdateCustomerDisplayMyCircleData {
  ybUpdateCustomerDisplayMyCircle: {
    customerUuid: string
    displayMyCircle: boolean
  }
}

export interface UpdateCustomerDisplayMyCircleVars {
  input: UpdateCustomerDisplayMyCircleInput
}

const useUpdateCustomerDisplayMyCircle = () =>
  useMutation<
    UpdateCustomerDisplayMyCircleData,
    UpdateCustomerDisplayMyCircleVars
  >(UPDATE_CUSTOMER_DISPLAY_MY_CIRCLE, {
    errorPolicy: 'all',
    awaitRefetchQueries: true,
    refetchQueries: (result) => {
      const customerUuid = result.data.ybUpdateCustomerDisplayMyCircle.customerUuid
      if (customerUuid) {
        return [
          {
            query: GET_CUSTOMER_DISPLAY_MY_CIRCLE,
            variables: { input: { customerUuid} },
          },
        ]
      }
      return []
    },
  })

export default useUpdateCustomerDisplayMyCircle